import { memo } from 'react';

import styled from '@emotion/styled';
import { Grid, Typography } from '@kc-console/common-ui';

import { LnbDivider } from '../LnbDivider';
import ServiceListItem from './ServiceListItem';

import type { Menus } from '@kc-console/context';

interface Props {
  collapsed: boolean;
  label: string;
  menus: Menus[];
  showDivider: boolean;
}

function ServiceScopeGroup({ label, menus, collapsed, showDivider }: Props) {
  return (
    <ScopeGroup>
      {showDivider && <LnbDivider />}
      {!collapsed && (
        <ScopeTitleItem>
          <Typography variant="label/medium/md" color="text/weaker/default">
            {label}
          </Typography>
        </ScopeTitleItem>
      )}
      {menus.map(menu => (
        <ServiceListItem key={menu.path} menu={menu} collapsed={collapsed} />
      ))}
    </ScopeGroup>
  );
}

export default memo(ServiceScopeGroup);

const ScopeGroup = styled('li')``;
const ScopeTitleItem = styled(Grid)`
  display: flex;
  align-items: center;
  padding: 0 16px 0 24px;
  height: 40px;
`;
